import { FC } from "react";
import {
  InRange,
  OutOfRange,
  SimpleRange,
} from "../../trade/components/Orders/shared/RangeBar";
import { FinRangeStatus } from "../analytics/__generated__/AlgorithmicLeaderboardQuery.graphql";
import { RangeNode } from "../leaderboard/types";

export const RangeCell: FC<{ node: RangeNode; status: FinRangeStatus }> = ({
  node,
  status,
}) => {
  const low = BigInt(node.low);
  const high = BigInt(node.high);
  if (status === "CLOSED") return <SimpleRange low={low} high={high} />;
  const current = BigInt(node.price);
  return current >= low && current <= high ? (
    <InRange current={current} low={low} high={high} />
  ) : (
    <OutOfRange current={current} low={low} high={high} />
  );
};
